import { FC } from 'react'

import { Box, Skeleton, Stack, Typography, useTheme } from '@mui/material'

import { DataCardProps } from './DataCard'

type DataCardSkeletonProps = Omit<DataCardProps, 'title'>

export const DataCardSkeleton: FC<DataCardSkeletonProps> = ({
  Sx,
  headerPostfixActions,
  testId,
  children
}) => {
  const theme = useTheme()

  return (
    <Stack
      data-testid={testId || 'skeleton-table-card'}
      sx={{
        borderRadius: Number(theme.shape.borderRadius) / 2,
        boxShadow: theme.shadows[5],
        position: 'relative',
        backgroundColor:
          theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.grey[800],
        ...Sx?.card
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{
          backgroundColor:
            theme.palette.mode === 'light' ? 'background.default' : 'background.paper',
          color: 'text.primary',
          pl: 2,
          pr: 1,
          pt: 1,
          pb: 0.8,
          minHeight: theme.palette.card.header.minHeight,
          borderTopLeftRadius: Number(theme.shape.borderRadius) * 2,
          borderTopRightRadius: Number(theme.shape.borderRadius) * 2,
          ...Sx?.header
        }}
      >
        <Stack direction="row" alignItems="center">
          <Typography variant="h6" fontWeight="bold" noWrap mr={2}>
            <Skeleton width={100} />
          </Typography>
        </Stack>

        {headerPostfixActions && (
          <Stack
            flexGrow={1}
            direction="row"
            gap={1}
            justifyContent="flex-end"
            alignItems="center"
            mt={-0.15}
          >
            {headerPostfixActions}
          </Stack>
        )}
      </Stack>
      <Box position="relative">{children}</Box>
    </Stack>
  )
}
